import { DropDownDto } from "./dropdowndto";

export interface ProfileTuneDropDownDto extends DropDownDto
{
    getType():string;
    getTitle(): string;
    getId():string;
    getIconName():string;
}

export class ProfileTuneDropDownDtoImpl implements ProfileTuneDropDownDto
{
    private type:string;
    private title: string;
    private id: string;
    private iconName: string;
   

    getType():string{

        return this.type;
    }

    setType(type:string):void
    {
        this.type = type;
    }
    getTitle():string
    {
        return this.title;
    }

    setTitle(title: string)
    {
        this.title = title;
    }
     
    getId():string
    {
        return this.id;
    }

    setId(id:string)
    {
        this.id = id;
    }

    getIconName():string
    {
        return this.iconName;
    }

    setIconName(iconName:string)
    {
        this.iconName = iconName;
    }

}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/dropdown/profiletunedropdowndto.ts